import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { TurnoAsignadoRepresentante, TurnoAtencionActiva } from '../models/citas.models';

@Injectable({ providedIn: 'root' })
export class TurnoAtencionActivaService {
  private readonly activoSubject = new BehaviorSubject<TurnoAtencionActiva | null>(null);
  private readonly concluidoSubject = new Subject<void>();
  private readonly pausadoSubject = new Subject<void>();

  /** Observable del turno en atención actual */
  readonly activo$: Observable<TurnoAtencionActiva | null> = this.activoSubject.asObservable();

  /** Emite cuando se concluye la atención (para refrescar listas) */
  readonly atencionConcluida$: Observable<void> = this.concluidoSubject.asObservable();

  /** Emite cuando se pausa la atención (para refrescar listas) */
  readonly atencionPausada$: Observable<void> = this.pausadoSubject.asObservable();

  /** Valor actual sincrónico */
  get activo(): TurnoAtencionActiva | null {
    return this.activoSubject.value;
  }

  /** Establece turno en atención desde objeto de lista */
  establecerDesdeTurno(turno: TurnoAsignadoRepresentante, representanteId: number): void {
    const tramites = (turno.tramites ?? []).map((t) => t.nombre ?? '').filter(Boolean);
    const nombre = turno.nombre_maestro || turno.persona_completa || 'Sin nombre';
    this.activoSubject.next({
      turno_id: turno.id,
      representante_id: representanteId,
      numero_turno: turno.numero_turno,
      maestro_id: turno.maestro_id ?? null,
      rfc: turno.rfc ?? null,
      nombre_socio: nombre,
      tramites,
      genero: turno.genero ?? null,
      pidio_informes: !!turno.pidio_informes,
    });
  }

  /** Marca el turno activo como atención de solicitud de información. */
  marcarSolicitudInformes(): void {
    const actual = this.activoSubject.value;
    if (!actual) {
      return;
    }
    this.activoSubject.next({
      ...actual,
      pidio_informes: true,
    });
  }

  /** Actualiza maestro_id tras vincular visitante */
  actualizarMaestroId(
    maestroId: number,
    rfc?: string | null,
    nombre?: string,
    genero?: string | null,
  ): void {
    const actual = this.activoSubject.value;
    if (!actual) {
      return;
    }
    this.activoSubject.next({
      ...actual,
      maestro_id: maestroId,
      rfc: rfc ?? actual.rfc,
      nombre_socio: nombre ?? actual.nombre_socio,
      genero: genero ?? actual.genero,
    });
  }

  /** Limpia turno en atención; notifica para refrescar listas si aplica */
  limpiar(opciones: { trasConcluir?: boolean; trasPausar?: boolean } = {}): void {
    this.activoSubject.next(null);
    if (opciones.trasConcluir) {
      this.concluidoSubject.next();
    }
    if (opciones.trasPausar) {
      this.pausadoSubject.next();
    }
  }
}
